const AboutSection = () => {
  const teamMembers = [
    'https://readdy.ai/api/search-image?query=professional%20marketing%20expert%20headshot%20portrait%20with%20confident%20smile%20in%20modern%20office%20setting%20with%20natural%20lighting%20and%20clean%20background&width=80&height=80&seq=team1&orientation=squarish',
    'https://readdy.ai/api/search-image?query=experienced%20digital%20strategist%20professional%20portrait%20with%20friendly%20expression%20in%20contemporary%20workspace%20with%20soft%20lighting%20and%20minimal%20background&width=80&height=80&seq=team2&orientation=squarish',
    'https://readdy.ai/api/search-image?query=creative%20marketing%20professional%20headshot%20with%20warm%20smile%20in%20bright%20modern%20office%20environment%20with%20clean%20aesthetic%20background&width=80&height=80&seq=team3&orientation=squarish',
    'https://readdy.ai/api/search-image?query=senior%20marketing%20consultant%20professional%20portrait%20with%20approachable%20demeanor%20in%20sleek%20office%20space%20with%20neutral%20toned%20background&width=80&height=80&seq=team4&orientation=squarish',
  ];

  return (
    <section className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="bg-cream rounded-3xl p-12 space-y-8">
            <div className="text-sm font-semibold tracking-wider uppercase text-gray-600">
              /ABOUT US
            </div>
            
            <p className="text-4xl font-serif text-gray-800 leading-relaxed">
              We are a team of passionate digital marketing experts dedicated to helping businesses achieve extraordinary growth through innovative strategies and data-driven solutions that deliver measurable results.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              At GrowthLink, we specialize in delivering comprehensive digital marketing solutions that drive measurable results. Our team of experts combines creativity with data-driven strategies to help businesses thrive in the digital landscape.
            </p>

            <div className="mb-8 p-6 bg-gradient-to-r from-primary/5 to-secondary/5 rounded-2xl border border-primary/10">
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-global-line text-2xl text-primary"></i>
                <h3 className="text-xl font-bold text-dark">Global Reach</h3>
              </div>
              <p className="text-gray-600">
                Proudly serving clients across India, USA, UK, UAE, and Qatar with tailored digital marketing solutions.
              </p>
            </div>

            <div className="flex items-center gap-4 pt-6">
              <div className="flex -space-x-3">
                {teamMembers.map((member, index) => (
                  <div key={index} className="w-16 h-16 rounded-full border-4 border-cream overflow-hidden">
                    <img
                      src={member}
                      alt={`Team member ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
              <span className="text-base font-medium text-gray-700">
                +50 Team Members
              </span>
            </div>
          </div>

          {/* Right Illustration */}
          <div className="relative h-[600px]">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20isometric%203D%20illustration%20of%20digital%20marketing%20workspace%20with%20floating%20holographic%20screens%20displaying%20analytics%20charts%20graphs%20and%20social%20media%20icons%20interconnected%20with%20glowing%20lines%20in%20vibrant%20purple%20cyan%20and%20orange%20colors%20against%20clean%20gradient%20background%20representing%20data-driven%20marketing%20technology%20and%20innovation&width=800&height=800&seq=about1&orientation=squarish"
              alt="Digital Marketing Workspace Illustration"
              className="w-full h-full object-contain rounded-3xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
